import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels, NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { QRCodeComponent  } from 'angularx-qrcode';


@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone:true,
    imports: [CommonModule,QRCodeComponent ],
    selector: 'app-qrcode-viewer',
   template: `
    <qrcode cssClass="qrcodeclassin" 
            [qrdata]="value"  
            [elementType]="elementType"
            [errorCorrectionLevel]="correctionLevel">
    </qrcode>`,

  
    styles: [`

  :host {
    display: block;
  }
  ::ng-deep .qrcodeclassin {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
  }
  
  `]
})

export class QrcodeViewerComponent implements OnInit {

  @Input() value: string;
  @Input() correctionLevel = NgxQrcodeErrorCorrectionLevels.LOW;
  
  protected elementType = NgxQrcodeElementTypes.IMG;

  constructor(
  ) {}

  ngOnInit(): void {
    // genera il qrcode
    console.log('ngOnInit QrcodeRilViewer');
  }
}
